import { get } from "lodash/fp";

export const isLoadingSelector = state => get("auth.isLoading")(state);

export const getCredential = state => get("auth.credential")(state);
export const getUser = state => get("auth.user")(state);
